import { render, staticRenderFns } from "./rdwgc.vue?vue&type=template&id=009ff64e&scoped=true&"
import script from "./rdwgc.vue?vue&type=script&lang=js&"
export * from "./rdwgc.vue?vue&type=script&lang=js&"
import style0 from "./rdwgc.vue?vue&type=style&index=0&id=009ff64e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009ff64e",
  null
  
)

export default component.exports